import { locales } from '@americanexpress/conditional-features';

const {
  DE_DE,
  EN_AU,
  EN_GB,
  EN_IN,
  EN_NZ,
  EN_US,
  ES_ES,
  FR_FR,
  IT_IT,
  JA_JP,
  NL_NL,
  SV_SE,
  EN_HK,
  EN_SG,
  ZH_HK,
} = locales;

export const MARKET_CONFIG_OVERRIDES = {
  [DE_DE]: {
    MIN_ADVANCE_BOOKING: 1,
    MAX_ADVANCE_BOOKING: 500,
  },
  [EN_AU]: {
    MIN_ADVANCE_BOOKING: 1,
  },
  [EN_GB]: {
    MIN_ADVANCE_BOOKING: 1,
    MAX_ADVANCE_BOOKING: 500,
  },
  [EN_IN]: {
    MIN_ADVANCE_BOOKING: 1,
  },
  [EN_NZ]: {
    MIN_ADVANCE_BOOKING: 1,
  },
  [EN_US]: {
    MAX_NIGHTS: 28,
    MAX_ADVANCE_BOOKING: 330,
    MAX_TRAVELERS_PER_ROOM: 6,
    MAX_TRAVELERS_CAP: 8,
    MAX_ROOMS: 4,
    MAX_CHILDREN: 5,
  },
  [ES_ES]: {
    MIN_ADVANCE_BOOKING: 1,
  },
  [FR_FR]: {
    MIN_ADVANCE_BOOKING: 1,
  },
  [IT_IT]: {
    MIN_ADVANCE_BOOKING: 1,
  },
  [JA_JP]: {
    MIN_ADVANCE_BOOKING: 1,
    MAX_TRAVELERS_CAP: 36,
    MAX_ADULTS: 9,
  },
  [NL_NL]: {
    MIN_ADVANCE_BOOKING: 1,
  },
  [SV_SE]: {
    MIN_ADVANCE_BOOKING: 1,
  },
  [EN_HK]: {
    MIN_ADVANCE_BOOKING: 2,
  },
  [EN_SG]: {
    MIN_ADVANCE_BOOKING: 2,
  },
  [ZH_HK]: {
    MIN_ADVANCE_BOOKING: 2,
  },
};

export const DEFAULT_CONFIG = {
  MIN_NIGHTS: 1,
  MAX_NIGHTS: 331,
  MIN_ADVANCE_BOOKING: 0,
  MAX_ADVANCE_BOOKING: 331,
  MAX_TRAVELERS_PER_ROOM: 9,
  MAX_TRAVELERS_CAP: 27,
  MAX_ROOMS: 3,
  MAX_ADULTS: 6,
  MAX_CHILDREN: 3,
};
